module.exports = __webpack_public_path__ + "static/media/INDICE DE INFORMACION CLASIFICADA Y RESERVADA NOTARIA.231c8b97.pdf";